// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2wT2i","error":"Textarea_error__146Pg","readonly":"Textarea_readonly__2JcBr","disabled":"Textarea_disabled__3YPE3"};